import { render, staticRenderFns } from "./changePassSecond.vue?vue&type=template&id=8f95c7a4&"
import script from "./changePassSecond.vue?vue&type=script&lang=js&"
export * from "./changePassSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports